import { useIntl } from 'react-intl';
import { Button } from './ui/button.tsx';

export function AnonymousPasskeyActions({
  isActing,
  onSignIn,
  onSignUp,
}: {
  isActing: boolean;
  onSignIn: () => void;
  onSignUp: () => void;
}) {
  const intl = useIntl();
  return (
    <div className="flex flex-wrap gap-3">
      <Button
        className="min-h-11 font-semibold"
        variant="default"
        disabled={isActing}
        onClick={onSignIn}
        type="button"
      >
        {intl.formatMessage({
          id: isActing ? 'web.auth.waiting' : 'web.auth.signIn',
        })}
      </Button>
      <Button
        className="min-h-11 font-semibold"
        variant="secondary"
        disabled={isActing}
        onClick={onSignUp}
        type="button"
      >
        {intl.formatMessage({ id: 'web.auth.signUp' })}
      </Button>
    </div>
  );
}
